// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fr-color-picker {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: #666;\n}\n.fr-color-picker .rc-color-picker-trigger {\n  margin-right: 12px;\n  height: 32px;\n  width: 60px;\n  border: 1px solid #e5e5e5;\n}\n.fr-color-picker > p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 28px;\n}\n.fr-color-picker .rc-color-picker-wrap {\n  display: flex;\n}\n", ""]);
// Exports
module.exports = exports;
